var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-icon',{attrs:{"size":this.size,"color":this.iconColor}},[_vm._v(_vm._s(_vm.getStickerIcon(this.iconName)))])}
var staticRenderFns = []

export { render, staticRenderFns }